<template>
  <div class="books">
    <div v-if="showTitle" class="title row">
      <i></i>
      <span class="flex cc">{{title}}</span>
      <a v-if="showRefresh" class="ccc refresh" @click="showRefreshAction">换一批</a>
      <a v-if="showMore" class="cc more" @click="showMoreAction">更多</a>
    </div>

    <ul v-if="books && books.length > 0" class="bookdetals">
      <li v-for="(item, index) in books" :key="index">
        <a class="row" @click="toBookDetail(item.bookId)">
          <div class="pic">
            <img imgtype="novel" :bookid="item.bookId" :booktitle="item.title" :chapternum="0" :imgpath="item.cover" :zoom="1000" v-lazy="require('../../assets/images/loading.jpeg')">
            <span v-if="item.showPop" :class="['book-pop', item.popClass]"></span>
          </div>
          <div class="flex book-detial cc">
            <b>{{item.title}}</b>
            <u>{{item.abstractContent}}</u>
            <s v-if="item.categoryName"><i>类型：{{item.categoryName}}</i></s>
            <p class="book-sum">
              <span class="tag-green">{{getPublishStatusText(item.publishStatus)}}</span>
            </p>
          </div>
        </a>
      </li>
    </ul>
    <div v-else class="h400">
      <div class="no_book">
        <p>暂时没有记录</p>
      </div>
    </div>
  </div>
</template>

<script>

  export default {
    name: "books-large",
    props: {
      title: String,
      books: Array,
      showTitle: {
        type: Boolean,
        default: true
      },
      showRefresh: {
        type: Boolean,
        default: false
      },
      showMore: {
        type: Boolean,
        default: true
      }
    },
    data() {
      return {}
    },
    methods: {
      showMoreAction() {
        this.$emit('show-more');
      },
      toBookDetail(id) {
        this.$router.isBack = false;
        this.$router.push(`/novels/${id}`)
      },
      showRefreshAction(){
        this.$emit('show-refresh');
      },
      getPublishStatusText(code) {
        if (code === 'finish') {
          return '完结'
        } else {
          return '连载'
        }
      }
    },
    watch: {
      books(data) {
      }
    }
  }
</script>

<style scoped>
.book-tag {
  bottom: 1.2rem !important;
}
.book-detial>b { min-height: 1rem;  height: auto;}
</style>



// WEBPACK FOOTER //
// src/components/novel/books-large.vue